import { Col, Nav, NavDropdown, Row } from "react-bootstrap";
import { AiOutlineUser } from "react-icons/ai";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { logoutFetch } from "../../../Api/Auth/LogoutFetch";
import authContext from "../../../Contexts/authContext";
import { IoIosLogOut } from "react-icons/io";
import { GoArrowSwitch } from "react-icons/go";
import Notifications from "../Notifications";

const UserSubmenuHolder = (props) => {
    const { logout } = useContext(authContext);
    const [pageTitle, setPageTitle] = useState('');
    const location = useLocation();

    // 1. Calcolo del numero totale di associazioni disponibili
    const totalAssociations = props.user?.profiles?.reduce(
        (acc, profile) => acc + (profile.associations?.length || 0),
        0
    ) || 0;

    // Determina se mostrare il tasto per cambiare profilo
    const showSwitchProfile = totalAssociations > 1;
    console.log(showSwitchProfile, totalAssociations)

    const handleLogout = () => {
        logoutFetch({ setSelectedUser: props.setSelectedUser, setUser: props.setUser });
        setTimeout(() => { logout() }, 500);
    }

    useEffect(() => {
        const titoliPagine = {
            '/lista-soci': 'Lista Anagrafiche',
            '/dettaglio-socio': 'Dettaglio anagrafica',
            '/aggiungi-socio': 'Aggiungi anagrafica',
            '/modifica-socio': 'Modifica anagrafica',
            '/lista-teams': 'Lista Teams',
            '/dettaglio-team': 'Dettaglio Team',
            '/lista-comunicazioni': 'Lista Comunicazioni',
            '/nuova-comunicazione': 'Nuova comunicazione',
            '/nuovo-team': 'Nuovo Team',
            '/modifica-team': 'Modifica Team',
            '/nuova-partita': 'Nuova gara',
            '/modifica-partita': 'Modifica gara',
            '/dettaglio-partita': 'Dettaglio gara',
            '/dettaglio-comunicazione': 'Dettaglio Comunicazione',
            '/allenamenti': 'Allenamenti',
            '/nuovo-piano-allenamento': 'Nuovo Piano allenamenti',
            '/impostazioni': 'Impostazioni',
            '/nuova-associazione': 'Nuova Associazione',
            '/lista-associazioni': 'Lista associazioni',
            '/modifica-associazione': 'Modifica associazione',
            '/gare': 'Lista Gare',
            '/lista-pagamenti': 'Lista Pagamenti',
            '/overview': 'Overview Pagamenti',
            '/report': 'Report pagamenti',
            '/home': 'Dashboard',
            '/importa': 'Importa Anagrafiche'
        };

        const currentPath = location.pathname;
        const titoloCorrispondente = Object.keys(titoliPagine).find(key => currentPath.includes(key));
        setPageTitle(titoliPagine[titoloCorrispondente] || 'Pagina Generica');
    }, [location.pathname]); // Dipendenza corretta per aggiornare il titolo al cambio rotta

    return (
        <Row className="px-2 px-sm-5 mx-0 d-flex mb-3 align-items-center flex-row">
            <Col md={7} className="text-start text-secondary">
                <h2 className="text-start text-second text-uppercase fw-bold mb-2">{pageTitle}</h2>
            </Col>

            <Col className="text-center justify-content-center mx-0 card shadow border-0 bkg-second text-white">
                <div className="text-black position-relative my-3 align-items-center justify-content-between text-end d-flex iconSubmenuHolder">
                    <div className="text-start text-white mb-0 small">
                        <b>{props.userProfile?.profile_name} - {props.userProfile?.association_name}</b>
                        <br/>
                        <span className="text-smaller">Stagione: {props.userProfile?.season}</span> <br />
                        <span>{props.userProfile?.email}</span>
                    </div>

                    <Nav className="ms-auto">
                        <Notifications />
                        <NavDropdown
                            title={<div className="bgGradient rounded-5 mb-0 p-1"><AiOutlineUser className="text-white fs-2"/></div>}
                            id="basic-nav-dropdown"
                            className="align-items-center d-inline-flex"
                        >

                            {showSwitchProfile && (
                                <NavDropdown.Item onClick={() => {
                                    localStorage.removeItem('selectedProfile');
                                    props.setSelectedUser(null);
                                }}>
                                    <GoArrowSwitch className="fs-4 me-2"/>Cambia profilo/associazione
                                </NavDropdown.Item>
                            )}

                            <NavDropdown.Item onClick={handleLogout}>
                                <IoIosLogOut className="fs-4 me-2"/>Esci
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </div>
            </Col>
        </Row>
    );
}

export default UserSubmenuHolder;